import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { auth } from 'src/services/firebase-service';
import logging from 'src/services/logging';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

const ForgotPage = () => {
  const [sending, setSending] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [error, seterror] = useState<string>('');

  const resetPassword = (data: any) => {
    if (error !== '') seterror('');

    setSending(true);

    sendPasswordResetEmail(auth, data.email)
      .then(() => {
        logging.info('Forgot password email sent.', 'ForgotPage');
        setSent(true);
        setSending(false);
      })
      .catch((error) => {
        logging.error(error, 'ForgotPage');

        if (error.code.includes('auth/user-not-found')) {
          seterror('User not found.');
        } else {
          seterror(error.message);
        }

        setSending(false);
      });
  };

  return (
    <Container maxWidth='sm'>
      <Card>
        <CardHeader title='Forgot Password' />
        <Divider />
        <CardContent>
          {sent ? (
            <Typography>
              A link has been sent to your email with instructions.
            </Typography>
          ) : (
            <Formik
              initialValues={{
                email: '',
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().label('Email').email().max(50).required(),
              })}
              onSubmit={(data) => {
                resetPassword(data);
              }}
            >
              {({ errors, handleChange, isValid, touched }) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        name='email'
                        type='email'
                        label='Email Address'
                        fullWidth={true}
                        error={!!(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        disabled={sending || !isValid}
                        variant='contained'
                        fullWidth={true}
                        type='submit'
                      >
                        {sending ? (
                          <CircularProgress size={24} color='inherit' />
                        ) : (
                          'Reset Password'
                        )}
                      </Button>
                    </Grid>
                    {error && (
                      <Grid item>
                        <Typography sx={{ color: '#d32f2f' }}>
                          {error}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Form>
              )}
            </Formik>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default ForgotPage;
